const SERVER_BASE_URL = 'https://service.customer.tcc-integration.toyota.itsd-consulting.services';
const API_BACKEND_BASE_URL = 'https://service.tcc-integration.toyota.itsd-consulting.services';

export const environment = {
  production: false,
  logEnabled: true,
  showDebug: false,
  sitekey: '6LcnhBEpAAAAAEEALGBVXjKm7H8u0f5YJREzb2t9',
  name: 'INT',
  country: 'DE',
  eweUrl: 'https://service.tcc-integration.toyota.itsd-consulting.services/toyota/ewe/{consentVersion}/html',
  dsiUrl: 'https://service.tcc-integration.toyota.itsd-consulting.services/toyota/dsi/{consentVersion}/pdf',
  endpoints: {
    getCustomerConsent: `${SERVER_BASE_URL}/customer-consent`,
    confirmCustomerConsent: `${SERVER_BASE_URL}/customer-consent/confirm/{brand}/{verificationtoken}`,
    denyCustomerConsent: `${SERVER_BASE_URL}/customer-consent/deny/{brand}/{verificationtoken}`,
    checkVerificationToken: `${SERVER_BASE_URL}/customer-consent/check/{verificationtoken}`,
    getCustomerMailWizardData: `${SERVER_BASE_URL}/customer-consent/customerWizardData/{brand}/{verificationToken}`,
    confirmCustomerConsentFromMailWizard: `${SERVER_BASE_URL}/customer-consent/mailwizard/confirm/{brand}/{verificationToken}`,
    getCustomerDigSigWizardData: `${SERVER_BASE_URL}/consent/digSigWizardData/{brand}/{tecCustomerId}/{dealerId}/{userToken}`,
    confirmCustomerConsentFromDigSigWizard: `${SERVER_BASE_URL}/consent/digSigConfirm/{tecCustomerId}/{dealerId}/{userToken}/sendMail/{sendMail}`,
    denyCustomerConsentFromDigSigWizard: `${SERVER_BASE_URL}/consent/digSigDeny/{tecCustomerId}/{dealerId}/{userToken}`,
    confirmCustomerConsentFromWizard: `${SERVER_BASE_URL}/customer-consent/wizard/confirm/{brand}`,
    getCustomerWizardData: `${SERVER_BASE_URL}/customer-consent/customerWizardData/{brand}`,
    lookup: `${SERVER_BASE_URL}`,
    getDshDocumentPdf: `${SERVER_BASE_URL}/{brand}/dsh/pdf`,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
